import { useMemo } from 'react'

import calc from 'pared/Routes/renderer/utils/calc'

import useSales from '../common/useSales'

const useMonthlySales = () => {
  const { data, loading } = useSales()

  return {
    data: useMemo(() => {
      if (!data) return null

      return {
        ...data,
        total: calc(data.total, '/', 12),
      }
    }, [data]),
    loading,
  }
}

export default useMonthlySales
